import React from "react";

type Props = {
  width: number;
  height: number;
};

export const IconTopicsSVG: React.FC<Props> = (props) => {
  const { width, height } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox={`0 0 54 54`}
    >
      <g transform="translate(-1118 -7.947)">
        <g transform="translate(1118.168 7.947)">
          <g transform="translate(10.332 9.053)">
            <path d="M30.173,18.565a1.667,1.667,0,0,1,0-1.489l3.419-6.838a1.666,1.666,0,0,0-1.49-2.41h-4.8v6.246a1.25,1.25,0,0,1-2.5,0V6a4,4,0,0,0-4-4H6.986a.5.5,0,0,0-.5.5V21.483a.5.5,0,0,0,.5.5H19.444a1.245,1.245,0,0,1-.051,2.49H13.98v.009a3.33,3.33,0,0,0,3.331,3.33H32.1a1.666,1.666,0,0,0,1.49-2.41Z" />
            <path d="M2,0A2,2,0,0,0,0,2V35.586a2,2,0,0,0,4,0V2A2,2,0,0,0,2,0" />
          </g>
        </g>
      </g>
    </svg>
  );
};
